import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ae257b1a")

_pushScopeId("data-v-ae257b1a")
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "table__header row" }, [
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--rank cell--data" }, [
    /*#__PURE__*/_createVNode("i", { class: "icon-trophy" })
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--team" }, "Équipe"),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--data" }, [
    /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Match"),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Matchs joués"
    }, "M")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--data cell--point" }, [
    /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Points"),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Points"
    }, "Pts")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--data cell--win" }, [
    /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Victoires"),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Victoires"
    }, "V")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--data cell--loss" }, [
    /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Défaites"),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Défaites"
    }, "D")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--data cell--nul" }, [
    /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Nulles"),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Nulles"
    }, "N")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--pp cell--data" }, "PP"),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--pc cell--data" }, "PC"),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--diff cell--data" }, [
    /*#__PURE__*/_createVNode("span", {
      class: "text--long",
      itle: "Differentiel"
    }, [
      /*#__PURE__*/_createVNode("b", null, "+"),
      /*#__PURE__*/_createTextVNode(" / "),
      /*#__PURE__*/_createVNode("b", null, "-")
    ]),
    /*#__PURE__*/_createVNode("span", {
      class: "text--short",
      title: "Differentiel"
    }, [
      /*#__PURE__*/_createVNode("b", null, "+"),
      /*#__PURE__*/_createTextVNode("/"),
      /*#__PURE__*/_createVNode("b", null, "-")
    ])
  ]),
  /*#__PURE__*/_createVNode("span", { class: "header__cell cell cell--info" })
], -1)
const _hoisted_3 = { class: "table__body" }
const _hoisted_4 = { class: "row__cell cell cell--rank cell--data" }
const _hoisted_5 = { class: "row__cell cell cell--team team-name" }
const _hoisted_6 = { class: "row__cell cell cell--data" }
const _hoisted_7 = { class: "row__cell cell cell--data cell--point" }
const _hoisted_8 = { class: "row__cell cell cell--data" }
const _hoisted_9 = { class: "row__cell cell cell--data" }
const _hoisted_10 = { class: "row__cell cell cell--data cell--nul" }
const _hoisted_11 = { class: "row__cell cell cell--pp cell--data" }
const _hoisted_12 = { class: "row__cell cell cell--pc cell--data" }
const _hoisted_13 = { class: "row__cell cell cell--diff cell--data" }
const _hoisted_14 = { class: "row__cell cell cell--info" }
const _hoisted_15 = {
  key: 0,
  title: "Classement provisoire"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-attention-circled" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ranking, (stats, ix) => {
        return (_openBlock(), _createBlock("div", {
          key: ix,
          class: "row"
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(ix + 1), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_TeamLabel, {
              team: _ctx.teamInfo(stats.team)
            }, null, 8, ["team"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", null, _toDisplayString(stats.games), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", null, _toDisplayString(stats.points), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", null, _toDisplayString(stats.win), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", null, _toDisplayString(stats.lost), 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("span", null, _toDisplayString(stats.nul), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", null, _toDisplayString(stats.pf), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("span", null, _toDisplayString(stats.pa), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("span", null, _toDisplayString(stats.diff), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            (stats.awaitingApproval)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _hoisted_16
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
})